
<template>
    <div id="ods-card">
        <div class="row">
            <div class="col-12">
                <div class="section-heading heading-left mb--20 mb_md--70">
                    <span class="subtitle primary">
                        <slot name="title"></slot>
                    </span>
                    <slot name="description">

                    </slot>
                    <!-- ICONOS -->
                    <div v-if="needIcon" class="row mb--40">
                        <div class="col-3">
                            <div class="author-info">
                                <div class="thumb">
                                    <img :src="`${imgBase}${icon1}.png`" alt="step-1">
                                </div>
                                <div class="content">
                                    <span class="name">
                                        <slot name="goal"></slot>
                                    </span>
                                </div>
                            </div>
                            
                        </div>
                        <div v-if="icon2 != null" class="col-3">
                            <div class="author-info">
                                <div class="thumb">
                                    <img  :src="`${imgBase}${icon2}.png`" alt="step-1">
                                </div>
                                <div class="content">
                                    <span class="name">{{ getIconName(icon2) }}</span>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-3">
                            <div class="author-info">
                                <div class="thumb">
                                    <img  :src="`${imgBase}${icon3}.png`" alt="step-1">
                                </div>
                                <div class="content">
                                    <span class="name">Impacto {{ icon3 == "primary" ? 'primario' : 'secundario' }}</span>
                                </div>
                            </div>
                        </div> -->
                    </div>

                    <!-- LÍNEAS DE ACCIÓN -->
                    <div class="row">
                        <div class="col-12">
                            <p class="bold primary title-green">
                                <slot name="line-action-title"></slot>
                            </p>
                            <p class="bold black">
                                <slot name="line-action"></slot>
                            </p>
    
                        </div>

                        <div class="col-12">
                            <slot name="body"></slot>
                        </div>

                        <div v-if="needChart" class="col-12">
                            <line-chart class="w-75"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
        
<script>
import lineChart from './line-chart.vue';
export default {
    name: "OdsDetails",
    props: ["needChart", "needIcon", "icon1", "icon2", "icon3"],
    components: {
        lineChart
    },
    data() {
        return {
            imgBase: "https://cdn.redgirasol.com/nuevo_portal/icons/icon-impact-"
        }
    },

    methods: {
        getIconName(icon) {
            const categories = {
                'leaf': "RedGirasol",
                'rayo': "Energía",
                '3r': "Residuos",
                'tree': "Ecosistemas",
                'agronegocios': "Agronegocios",
                'construccion': "Construcción",
            }

            return categories[icon] || null;
        }
    }
}
</script>
        
<style scoped>
.author-info {
    display: flex;
    align-items: center;
}

    .author-info .thumb {
        margin-right: 1rem;
        width: 5rem;
    }

    .title-green {
        margin-bottom: -0.5rem !important;
    }

    ul {
        list-style: none;
        padding-left: 0;
    }

    li {
        font-weight: 700;
    }

    ul li:before {
        content: '✓';
        margin-right: 1rem;
        color: var(--color-primary);
        font-weight: 700;
    }
</style>
